import React, { useState } from 'react';
import { authAPI } from '../services/api';
import { createClient } from '@supabase/supabase-js';

const supabase = createClient(
  'https://fzyjklucvinpclxuzqwa.supabase.co',
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZ6eWprbHVjdmlucGNseHV6cXdhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDM4NjY4MzEsImV4cCI6MjA1OTQ0MjgzMX0.o_o0SQzaKnBfSSUSBuKHhq9dTsQFbsqAZBMhz8CuRaE'
);

function Input({ label, value, onChange, placeholder, type = 'text', required, autoComplete }) {
  return (
    <div style={{ marginBottom: 14 }}>
      <label style={{ display: 'block', fontSize: 11, color: '#4a7abf', marginBottom: 4, fontWeight: 500 }}>
        {label}{required && ' *'}
      </label>
      <input
        type={type}
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder={placeholder}
        autoComplete={autoComplete}
        style={{ width: '100%', background: '#111', border: '0.5px solid #1a2744', borderRadius: 8, padding: '10px 12px', fontSize: 13, color: '#c8d4e8', outline: 'none', boxSizing: 'border-box' }}
      />
    </div>
  );
}

export function Login({ onLogin, onSignup, onForgot }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const login = async () => {
    if (!email || !password) return;
    setLoading(true); setError('');
    try {
      const res = await authAPI.login(email, password);
      localStorage.setItem('compagnon_token', res.access_token);
      localStorage.setItem('compagnon_user_id', res.user_id);
      localStorage.setItem('compagnon_login_time', Date.now().toString());
      onLogin(res.artisan);
    } catch (e) {
      setError('Email ou mot de passe incorrect.');
    } finally { setLoading(false); }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', minHeight: '100dvh', width: '100%', background: '#0a0a0a', padding: '0 24px', boxSizing: 'border-box' }}>
      <div style={{ width: '100%', maxWidth: 400 }}>
        <div style={{ marginBottom: 40, textAlign: 'center' }}>
          <div style={{ width: 56, height: 56, background: '#FFD700', borderRadius: 16, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px', fontSize: 28 }}>⚒</div>
          <h1 style={{ color: '#e8eaf0', fontSize: 26, fontWeight: 700, margin: '0 0 6px' }}>Compagnon</h1>
          <p style={{ color: '#4a7abf', fontSize: 13, margin: 0 }}>Votre assistant expert BTP</p>
        </div>
        <Input label="Email" value={email} onChange={setEmail} type="email" placeholder="vous@entreprise.fr" required autoComplete="email" />
        <Input label="Mot de passe" value={password} onChange={setPassword} type="password" placeholder="••••••••" required autoComplete="current-password" />
        {error && <p style={{ color: '#e05a5a', fontSize: 12, marginBottom: 12 }}>{error}</p>}
        <button onClick={login} disabled={loading} style={{ width: '100%', background: '#FFD700', color: '#0a0a0a', border: 'none', borderRadius: 20, padding: '13px 0', fontSize: 14, fontWeight: 700, cursor: 'pointer', marginBottom: 12 }}>
          {loading ? 'Connexion…' : 'Se connecter'}
        </button>
        <button onClick={onSignup} style={{ width: '100%', background: 'none', border: '0.5px solid #1a2744', borderRadius: 20, padding: '11px 0', fontSize: 13, color: '#4a7abf', cursor: 'pointer', marginBottom: 12 }}>
          Creer un compte artisan
        </button>
        <button onClick={onForgot} style={{ width: '100%', background: 'none', border: 'none', padding: '8px 0', fontSize: 12, color: '#4a7abf', cursor: 'pointer', textDecoration: 'underline' }}>
          Mot de passe oublie ?
        </button>
      </div>
    </div>
  );
}

export function ForgotPassword({ onBack }) {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const send = async () => {
    if (!email) return setError('Veuillez entrer votre email.');
    setLoading(true); setError('');
    try {
      await authAPI.forgotPassword(email);
      setSent(true);
    } catch (e) {
      setError("Erreur lors de l'envoi. Reessayez.");
    } finally { setLoading(false); }
  };

  if (sent) return (
    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', minHeight: '100dvh', background: '#0a0a0a', padding: '0 24px', boxSizing: 'border-box' }}>
      <div style={{ width: '100%', maxWidth: 400, textAlign: 'center' }}>
        <div style={{ fontSize: 56, marginBottom: 16 }}>📧</div>
        <h2 style={{ color: '#e8eaf0', fontSize: 20, fontWeight: 700, margin: '0 0 12px' }}>Email envoye !</h2>
        <p style={{ color: '#4a7abf', fontSize: 13, lineHeight: 1.7, margin: '0 0 8px' }}>Un lien de reinitialisation a ete envoye a votre adresse email.</p>
        <p style={{ color: '#4a7abf', fontSize: 12, lineHeight: 1.6, margin: '0 0 24px' }}>Verifiez aussi vos spams.</p>
        <button onClick={onBack} style={{ width: '100%', background: '#FFD700', color: '#0a0a0a', border: 'none', borderRadius: 20, padding: '13px 0', fontSize: 14, fontWeight: 700, cursor: 'pointer' }}>
          Retour a la connexion
        </button>
      </div>
    </div>
  );

  return (
    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', minHeight: '100dvh', background: '#0a0a0a', padding: '0 24px', boxSizing: 'border-box' }}>
      <div style={{ width: '100%', maxWidth: 400 }}>
        <div style={{ marginBottom: 32, textAlign: 'center' }}>
          <div style={{ width: 56, height: 56, background: '#FFD700', borderRadius: 16, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px', fontSize: 28 }}>⚒</div>
          <h2 style={{ color: '#e8eaf0', fontSize: 22, fontWeight: 700, margin: '0 0 8px' }}>Mot de passe oublie</h2>
          <p style={{ color: '#4a7abf', fontSize: 13, margin: 0 }}>Entrez votre email pour recevoir un lien de reinitialisation</p>
        </div>
        <Input label="Email" value={email} onChange={setEmail} type="email" placeholder="vous@entreprise.fr" required autoComplete="email" />
        {error && <p style={{ color: '#e05a5a', fontSize: 12, marginBottom: 12 }}>{error}</p>}
        <button onClick={send} disabled={loading} style={{ width: '100%', background: '#FFD700', color: '#0a0a0a', border: 'none', borderRadius: 20, padding: '13px 0', fontSize: 14, fontWeight: 700, cursor: 'pointer', marginBottom: 12 }}>
          {loading ? 'Envoi en cours…' : 'Envoyer le lien'}
        </button>
        <button onClick={onBack} style={{ width: '100%', background: 'none', border: 'none', padding: '8px 0', fontSize: 12, color: '#4a7abf', cursor: 'pointer', textDecoration: 'underline' }}>
          Retour a la connexion
        </button>
      </div>
    </div>
  );
}

export function ResetPassword({ onSuccess }) {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const reset = async () => {
    if (!password || !confirm) return setError('Remplissez les deux champs.');
    if (password.length < 8) return setError('Le mot de passe doit contenir au moins 8 caracteres.');
    if (password !== confirm) return setError('Les mots de passe ne correspondent pas.');
    setLoading(true); setError('');
    try {
      const { error } = await supabase.auth.updateUser({ password });
      if (error) throw error;
      onSuccess();
    } catch (e) {
      setError('Erreur lors de la reinitialisation. Reessayez.');
    } finally { setLoading(false); }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', minHeight: '100dvh', background: '#0a0a0a', padding: '0 24px', boxSizing: 'border-box' }}>
      <div style={{ width: '100%', maxWidth: 400 }}>
        <div style={{ marginBottom: 32, textAlign: 'center' }}>
          <div style={{ width: 56, height: 56, background: '#FFD700', borderRadius: 16, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px', fontSize: 28 }}>⚒</div>
          <h2 style={{ color: '#e8eaf0', fontSize: 22, fontWeight: 700, margin: '0 0 8px' }}>Nouveau mot de passe</h2>
          <p style={{ color: '#4a7abf', fontSize: 13, margin: 0 }}>Choisissez un nouveau mot de passe securise</p>
        </div>
        <Input label="Nouveau mot de passe (8 caracteres min)" value={password} onChange={setPassword} type="password" placeholder="••••••••" required autoComplete="new-password" />
        <Input label="Confirmer le mot de passe" value={confirm} onChange={setConfirm} type="password" placeholder="••••••••" required autoComplete="new-password" />
        {error && <p style={{ color: '#e05a5a', fontSize: 12, marginBottom: 12 }}>{error}</p>}
        <button onClick={reset} disabled={loading} style={{ width: '100%', background: '#FFD700', color: '#0a0a0a', border: 'none', borderRadius: 20, padding: '13px 0', fontSize: 14, fontWeight: 700, cursor: 'pointer' }}>
          {loading ? 'Enregistrement...' : 'Enregistrer le nouveau mot de passe'}
        </button>
      </div>
    </div>
  );
}

export function Signup({ onBack }) {
  const [form, setForm] = useState({ email: '', password: '', nom_entreprise: '', siret: '', adresse: '', telephone: '', tva_numero: '', assurance_decennale: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const signup = async () => {
    if (!form.email || !form.password || !form.nom_entreprise || !form.siret) return setError('Remplissez tous les champs obligatoires.');
    if (form.password.length < 8) return setError('Le mot de passe doit contenir au moins 8 caracteres.');
    setLoading(true); setError('');
    try {
      await authAPI.signup(form);
      setSuccess(true);
    } catch (e) { setError(e.message); }
    finally { setLoading(false); }
  };

  if (success) return (
    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', minHeight: '100dvh', width: '100%', background: '#0a0a0a', padding: '0 24px', boxSizing: 'border-box' }}>
      <div style={{ width: '100%', maxWidth: 400, textAlign: 'center' }}>
        <div style={{ fontSize: 64, marginBottom: 20 }}>🎉</div>
        <h2 style={{ color: '#e8eaf0', fontSize: 22, fontWeight: 700, margin: '0 0 12px' }}>Compte cree !</h2>
        <p style={{ color: '#4a7abf', fontSize: 14, lineHeight: 1.7, margin: '0 0 32px' }}>Votre compte a bien ete cree. Vous pouvez maintenant vous connecter !</p>
        <button onClick={onBack} style={{ width: '100%', background: '#FFD700', color: '#0a0a0a', border: 'none', borderRadius: 20, padding: '13px 0', fontSize: 14, fontWeight: 700, cursor: 'pointer' }}>
          Se connecter
        </button>
      </div>
    </div>
  );

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100dvh', background: '#0a0a0a' }}>
      <div style={{ background: '#0d1117', padding: '14px 16px', borderBottom: '0.5px solid #1a2744', display: 'flex', alignItems: 'center', gap: 12 }}>
        <button onClick={onBack} style={{ background: 'none', border: 'none', color: '#4a7abf', fontSize: 18, cursor: 'pointer' }}>←</button>
        <p style={{ color: '#e8eaf0', fontSize: 15, fontWeight: 600, margin: 0 }}>Creer mon compte</p>
      </div>
      <div style={{ flex: 1, overflowY: 'auto', padding: '20px 20px' }}>
        <p style={{ fontSize: 12, color: '#FFD700', fontWeight: 600, marginBottom: 12, textTransform: 'uppercase', letterSpacing: '0.06em' }}>Compte</p>
        <Input label="Email" value={form.email} onChange={v => set('email', v)} type="email" required autoComplete="email" />
        <Input label="Mot de passe (8 caracteres min)" value={form.password} onChange={v => set('password', v)} type="password" required autoComplete="new-password" />
        <p style={{ fontSize: 12, color: '#FFD700', fontWeight: 600, margin: '16px 0 12px', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Votre entreprise</p>
        <Input label="Nom de l'entreprise" value={form.nom_entreprise} onChange={v => set('nom_entreprise', v)} required placeholder="Maconnerie Dupont" autoComplete="organization" />
        <Input label="SIRET" value={form.siret} onChange={v => set('siret', v)} required placeholder="000 000 000 00000" autoComplete="off" />
        <Input label="Adresse" value={form.adresse} onChange={v => set('adresse', v)} placeholder="12 rue des Artisans, 75001 Paris" autoComplete="street-address" />
        <Input label="Telephone" value={form.telephone} onChange={v => set('telephone', v)} placeholder="06 00 00 00 00" autoComplete="tel" />
        <Input label="N TVA intracommunautaire" value={form.tva_numero} onChange={v => set('tva_numero', v)} placeholder="FR00 000000000 (optionnel)" autoComplete="off" />
        <Input label="Assurance decennale" value={form.assurance_decennale} onChange={v => set('assurance_decennale', v)} placeholder="Assureur + n police (optionnel)" autoComplete="off" />
        {error && <p style={{ color: '#e05a5a', fontSize: 12, marginBottom: 12 }}>{error}</p>}
        <button onClick={signup} disabled={loading} style={{ width: '100%', background: '#FFD700', color: '#0a0a0a', border: 'none', borderRadius: 20, padding: '13px 0', fontSize: 14, fontWeight: 700, cursor: 'pointer' }}>
          {loading ? 'Creation en cours...' : 'Creer mon compte'}
        </button>
      </div>
    </div>
  );
}

export default function Profil({ artisan, onLogout }) {
  const [editing, setEditing] = useState(false);
  const [form, setForm] = useState(artisan || {});
  const [loading, setLoading] = useState(false);
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const save = async () => {
    setLoading(true);
    try {
      await authAPI.updateProfil(artisan.id, form);
      setEditing(false);
      alert('Profil mis a jour !');
    } catch (e) { alert('Erreur : ' + e.message); }
    finally { setLoading(false); }
  };

  const field = (label, key, placeholder) => (
    <div style={{ borderBottom: '0.5px solid #1a2744', padding: '11px 0' }}>
      <p style={{ fontSize: 10, color: '#4a7abf', margin: '0 0 3px', fontWeight: 500, textTransform: 'uppercase', letterSpacing: '0.05em' }}>{label}</p>
      {editing
        ? <input value={form[key] || ''} onChange={e => set(key, e.target.value)} placeholder={placeholder}
            style={{ width: '100%', background: '#111', border: '0.5px solid #1a2744', borderRadius: 6, padding: '7px 10px', fontSize: 13, color: '#c8d4e8', outline: 'none', boxSizing: 'border-box' }} />
        : <p style={{ fontSize: 13, color: artisan?.[key] ? '#c8d4e8' : '#4a7abf', margin: 0 }}>{artisan?.[key] || placeholder}</p>
      }
    </div>
  );

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', background: '#0a0a0a' }}>
      <div style={{ background: '#0d1117', padding: '14px 16px 12px', borderBottom: '0.5px solid #1a2744', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexShrink: 0 }}>
        <p style={{ color: '#e8eaf0', fontSize: 15, fontWeight: 600, margin: 0 }}>Mon profil</p>
        <button onClick={() => editing ? save() : setEditing(true)} style={{ background: editing ? '#FFD700' : '#0e2040', border: `0.5px solid ${editing ? '#FFD700' : '#1e3a6e'}`, borderRadius: 20, padding: '5px 14px', fontSize: 12, color: editing ? '#0a0a0a' : '#85B7EB', fontWeight: 500, cursor: 'pointer' }}>
          {loading ? '...' : editing ? 'Enregistrer' : 'Modifier'}
        </button>
      </div>
      <div style={{ flex: 1, overflowY: 'auto', padding: '0 16px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 14, padding: '20px 0 16px', borderBottom: '0.5px solid #1a2744', marginBottom: 4 }}>
          <div style={{ width: 52, height: 52, background: '#FFD700', borderRadius: 16, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 24 }}>⚒</div>
          <div>
            <p style={{ color: '#e8eaf0', fontSize: 15, fontWeight: 600, margin: '0 0 3px' }}>{artisan?.nom_entreprise || 'Mon Entreprise'}</p>
            <p style={{ color: '#4a7abf', fontSize: 12, margin: 0 }}>{artisan?.email}</p>
          </div>
        </div>
        {field("Nom de l'entreprise", 'nom_entreprise', 'Maconnerie Dupont')}
        {field('SIRET', 'siret', '000 000 000 00000')}
        {field('Adresse', 'adresse', '12 rue des Artisans')}
        {field('Telephone', 'telephone', '06 00 00 00 00')}
        {field('N TVA', 'tva_numero', 'FR00 000000000')}
        {field('Assurance decennale', 'assurance_decennale', 'N police')}
        <div style={{ paddingTop: 24, paddingBottom: 24 }}>
          <button onClick={() => { localStorage.clear(); onLogout(); }} style={{ width: '100%', background: 'none', border: '0.5px solid #e05a5a', borderRadius: 20, padding: '11px 0', fontSize: 13, color: '#e05a5a', cursor: 'pointer' }}>
            Se deconnecter
          </button>
        </div>
      </div>
    </div>
  );
}
